<template>
  <div class="">
    <nav class="p-2 fm:px-4 px-8 relative fd:fixed shadow-lg w-full bg-white z-100">
      <div class="flex items-center justify-between">
        <div class="flex items-center fd:gap-8 fm:gap-4 relative">
          <div class="fd:hidden">
            <span class="cursor-pointer" @click="$store.state.toggleNav = !$store.state.toggleNav">
              <font-awesome-icon icon="fa-solid fa-bars" class="icon text-lg"/>
            </span>
          </div>
          <routerLink to="/">
            <img :src="$store.state.configSite.logo" class=""/>
          </routerLink>
          <ul :class="['flex fd:items-center gap-8 fm:gap-5 relative fm:flex-col fm:absolute fm:bg-white fm:shadow-lg fm:p-2 fm:z-100 fm:top-0 fm:h-screen fm:w-[24rem] fm:right-[-.9rem]',$store.state.toggleNav ? 'fm:flex' : 'fm:hidden']">
            <li class="fd:hidden fm:mb-5">
              <div class="flex justify-end">
                <span @click="$store.state.toggleNav = false">
                  <font-awesome-icon icon="fa-solid fa-times" class="icon text-lg"/>
                </span>
              </div>
            </li>
            <li class="relative group">
              <div class="hover:text-cyan-500 flex items-center gap-1">
                <span class="text-xs"><font-awesome-icon icon="fa-solid fa-home" class="icon"/></span>
                <routerLink to="/" class="text-lg fm:text-sm">خانه</routerLink>
              </div>
            </li>
            <li class="relative group">
              <div class="hover:text-cyan-500 flex items-center justify-between gap-1">
                <div class="flex items-center gap-2">
                  <span class="text-xs"><font-awesome-icon icon="fa-solid fa-book-open" class="icon"/></span>
                  <span class="text-lg fm:text-sm">دوره ها</span>
                </div>
                <span class="text-xs"><font-awesome-icon icon="fa-solid fa-chevron-down" class="icon"/></span>
              </div>
              <div class="hidden group-hover:block absolute w-[25rem] bg-white rounded-lg top-7 shadow-lg py-4 px-2 z-100" v-if="categories.length>0">
                <ul class="flex flex-col gap-3">
                  <li class="relative hover:mr-4 transition-all duration-300 ease-in-out group/sub-menu" v-for="category in categories" :key="category.id">
                    <div class="hover:text-cyan-500 flex items-center justify-between gap-1">
                      <routerLink :to="{name:'CourseCategory',params:{slug:category.slug}}" class="text-lg fm:text-sm">{{category.title}}</routerLink>
                    </div>
                  </li>
                </ul>
              </div>
            </li>
            <li class="relative group">
              <div class="hover:text-cyan-500 flex items-center justify-between gap-1">
                <div class="flex items-center gap-2">
                  <span class="text-xs text-black">
                    <svg class="svg-inline--fa fa-presentation fa-w-18" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="presentation" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" data-fa-i2svg=""><path fill="currentColor" d="M560 0H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h16v256c0 17.67 14.33 32 32 32h192v34.75l-75.31 75.31c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0L288 445.25l62.06 62.06c6.25 6.25 16.38 6.25 22.63 0l22.62-22.62c6.25-6.25 6.25-16.38 0-22.63L320 386.75V352h192c17.67 0 32-14.33 32-32V64h16c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16zm-80 288H96V64h384v224z"></path></svg>
                  </span>
                  <span class="text-lg fm:text-sm">رویداد ها</span>
                </div>
                <span class="text-xs"><font-awesome-icon icon="fa-solid fa-chevron-down" class="icon"/></span>
              </div>
              <div class="hidden group-hover:block absolute w-[25rem] bg-white rounded-lg top-7 shadow-lg p-2 z-100" v-if="eventCategories.length>0">
                <ul class="flex flex-col gap-5">
                  <li class="relative hover:mr-4 transition-all duration-300 ease-in-out group/sub-menu" v-for="category in eventCategories" :key="category.id">
                    <div class="hover:text-cyan-500 flex items-center justify-between gap-1">
                      <routerLink :to="{name:'EventList',params:{slug:category.slug}}" class="text-lg fm:text-sm">{{category.title}}</routerLink>
                    </div>
                  </li>
                </ul>
              </div>
            </li>
            <li class="relative group">
              <div class="hover:text-cyan-500 flex items-center justify-between gap-1">
                <div class="flex items-center gap-2">
                  <span class="text-xs"><font-awesome-icon icon="fa-solid fa-newspaper" class="icon"/></span>
                  <span class="text-lg fm:text-sm">مقالات</span>
                </div>
                <span class="text-xs"><font-awesome-icon icon="fa-solid fa-chevron-down" class="icon"/></span>
              </div>
              <div class="hidden group-hover:block absolute w-[25rem] bg-white rounded-lg top-7 shadow-lg p-2 z-100" v-if="newsCategories.length>0">
                <ul class="flex flex-col gap-5">
                  <li class="relative hover:mr-4 transition-all duration-300 ease-in-out group/sub-menu" v-for="category in newsCategories" :key="category.id">
                    <div class="hover:text-cyan-500 flex items-center justify-between gap-1">
                      <routerLink :to="{name:'ArticleList',params:{slug:category.slug}}" class="text-lg fm:text-sm">{{category.title}}</routerLink>
                    </div>
                  </li>
                </ul>
              </div>
            </li>
            <li class="relative group">
              <div class="hover:text-cyan-500 flex items-center gap-1">
                <span class="text-xs"><font-awesome-icon icon="fa-solid fa-info" class="icon"/></span>
                <routerLink :to="{name:'AboutUs'}" class="text-lg fm:text-sm">درباره ما</routerLink>
              </div>
            </li>
            <li class="relative group">
              <div class="hover:text-cyan-500 flex items-center gap-1">
                <span class="text-xs"> <font-awesome-icon icon="fa-solid fa-address-book" class="icon"/></span>
                <routerLink :to="{name:'ContactUsPage'}" class="text-lg fm:text-sm">تماس با ما</routerLink>
              </div>
            </li>
          </ul>
        </div>
        <div class="flex items-center gap-5">
          <div class="relative">
            <span class="text-gray-500 cursor-pointer" @click="$store.state.toggleSearch = !$store.state.toggleSearch">
              <font-awesome-icon icon="fa-solid fa-search" class="icon fm:text-sm"/>
            </span>
            <div :class="['absolute w-[25rem] top-6 fm:top-7 bg-white shadow-lg p-2 rounded-lg fd:left-[100%] fm:left-[-9rem]', $store.state.toggleSearch ? 'block' : 'hidden']">
              <Input type="search" v-debounce:1000="searchData" :debounce-events="['keydown']" id="search" placeholder="جستجوی دوره و همایش: متن خورد را بنویسید" :required="false" />

              <div class="overflow-y-scroll scroll h-[25rem] mt-10" v-if="$store.state.searchResult.length > 0">
                <div v-for="item in $store.state.searchResult" :key="item">
                  <routerLink :to="{name:'tuition' in item ? 'CourseDetail' : 'EventDetail', params:{slug:item.slug}}" class="flex flex-row gap-3">
                    <div class="w-[22%]">
                      <img :src="$store.state.url + item.image" class="rounded"/>
                    </div>
                    <div class="flex flex-col gap-3">
                      <span class="!font-medium fm:text-sm">{{item.title}}</span>
                      <span class="fm:text-sm">{{$store.getters.numberFormat('tuition' in item ? item.tuition : item.price)}} ریال</span>
                    </div>
                  </routerLink>
                  <div class="border-b my-2 border-gray-300"></div>
                </div>
              </div>
              <div v-else-if="$store.state.searchRequest" class="text-center">
                <span class="text-red-500 fm:text-sm">دوره ای یافت نشد</span>
              </div>
            </div>
          </div>
          <div v-if="$store.state.user.token === null">
            <routerLink :to="{name:'Login'}" class="flex items-center gap-2 border border-cyan-500 justify-between rounded-lg px-4 py-2 fm:px-2 fm:py-1">
              <span class="fm:text-sm text-green-500"><font-awesome-icon icon="fa-solid fa-user-plus" class="icon fm:text-lg"/></span>
              <span class="text-cyan-500 fm:text-sm">ورود/ثبت نام</span>
            </routerLink>
          </div>
          <div v-else>
            <routerLink :to="{name:'Dashboard'}" class="flex items-center gap-2 border border-cyan-500 justify-between rounded-lg px-4 py-2 fm:px-2 fm:py-1">
              <span class="fm:text-sm text-green-500"><font-awesome-icon icon="fa-solid fa-tachometer" class="icon text-2xl fm:text-lg"/></span>
              <span class="text-cyan-500 fm:text-sm">پنل کاربری</span>
            </routerLink>
          </div>
        </div>
      </div>
    </nav>
    <main class="fd:pt-[4.1rem]">
      <router-view/>
    </main>
    <footer class="flex flex-col mt-32 relative fm:mt-[14rem]">
      <div class="">
        <div class="w-[50%] border-b border-t border-r border-l rounded-tl-full border-[#424242] bg-[#424242] h-[8rem]"></div>
        <div class="absolute bg-white p-3 right-16 fm:right-[2rem] rounded-lg top-[-10%] !shadow-lg">
          <routerLink to="/">
            <img :src="$store.state.configSite.footer_logo" />
          </routerLink>
        </div>
      </div>
      <div class="flex flex-col bg-[#424242] w-full fm:pt-20">
        <div class="flex items-center justify-between fm:flex-col gap-5 fm:gap-10 mt-10 px-4">
          <div class="w-full">
            <p class="text-gray-300 fm:text-sm" v-html="$store.state.configSite.site_bio"></p>
          </div>

          <div class="w-full">
            <div class="flex items-center gap-1">
              <span class="fm:text-sm text-green-500">
                <svg class="svg-inline--fa fa-flower fa-w-14" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="flower" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M128 480c38.2 0 72.5-16.8 96-43.3c23.5 26.6 57.8 43.3 96 43.3c70.7 0 128-57.3 128-128c0-38.2-16.8-72.5-43.3-96c26.6-23.5 43.3-57.8 43.3-96c0-70.7-57.3-128-128-128c-38.2 0-72.5 16.8-96 43.3C200.5 48.8 166.2 32 128 32C57.3 32 0 89.3 0 160c0 38.2 16.8 72.5 43.3 96C16.8 279.5 0 313.8 0 352c0 70.7 57.3 128 128 128zm96-304a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"></path></svg>
              </span>
              <span class="fm:text-sm text-gray-300">دسترسی سریع</span>
            </div>
            <div class="border-b border-dashed border-white mb-4 mt-1"></div>
            <ul class="flex flex-col gap-4">
              <li>
                <routerLink :to="{name:'AboutUs'}" class="flex items-center gap-1">
                  <span class="flex text-sm text-gray-300"><font-awesome-icon icon="fa-solid fa-chevron-circle-left" class="icon"/></span>
                  <span class="text-sm text-gray-300">درباره ما</span>
                </routerLink>
              </li>
              <li>
                <routerLink :to="{name:'ContactUsPage'}" class="flex items-center gap-1">
                  <span class="flex text-sm text-gray-300"><font-awesome-icon icon="fa-solid fa-chevron-circle-left" class="icon"/>></span>
                  <span class="text-sm text-gray-300">تماس با ما</span>
                </routerLink>
              </li>
              <li>
                <routerLink :to="{name:'Login'}" class="flex items-center gap-1">
                  <span class="flex text-sm text-gray-300"><font-awesome-icon icon="fa-solid fa-chevron-circle-left" class="icon"/></span>
                  <span class="text-sm text-gray-300">ورود</span>
                </routerLink>
              </li>
            </ul>
          </div>
          <div class="w-full flex items-center justify-around gap-2">
            <div v-html="$store.state.configSite.enamad"></div>
            <div v-html="$store.state.configSite.samandehi"></div>
          </div>
        </div>
        <div class="flex items-center justify-between mt-10 bg-gray-600 p-4 rounded  fm:flex-col">
          <div>
            <span class="text-gray-400">© {{$store.getters.dateToPersian(new Date()).split('/')[0]}}. {{$store.state.configSite.copy_right}}</span>
          </div>
          <div class="flex items-center gap-4">
            <a v-bind:href="$store.state.configSite.social_media.instagram" target="_blank" class="w-[2rem] h-[2rem] rounded bg-gray-500 p-2 flex items-center">
              <span class="flex text-white"><font-awesome-icon icon="fa-brands fa-instagram" class="icon text-xl"/></span>
            </a>
            <a v-bind:href="$store.state.configSite.social_media.telegram" target="_blank" class="w-[2rem] h-[2rem] rounded bg-gray-500 p-2 flex items-center">
              <span class="flex text-white"><font-awesome-icon icon="fa-brands fa-telegram" class="icon text-xl"/></span>
            </a>
            <a v-bind:href="$store.state.configSite.social_media.whatsapp" target="_blank" class="w-[2rem] h-[2rem] rounded bg-gray-500 p-2 flex items-center">
              <span class="flex text-white"><font-awesome-icon icon="fa-brands fa-whatsapp" class="icon text-xl"/></span>
            </a>
            <a v-bind:href="$store.state.configSite.social_media.facebook" target="_blank" class="w-[2rem] h-[2rem] rounded bg-gray-500 p-2 flex items-center">
              <span class="flex text-white"><font-awesome-icon icon="fa-brands fa-facebook" class="icon text-xl"/></span>
            </a>
            <a v-bind:href="$store.state.configSite.social_media.twitter" target="_blank" class="w-[2rem] h-[2rem] rounded bg-gray-500 p-2 flex items-center">
              <span class="flex text-white"><font-awesome-icon icon="fa-brands fa-twitter" class="icon text-xl"/></span>
            </a>
          </div>
        </div>
      </div>
    </footer>
    <Loading :loading="loading" />
    <Meta :key="metaKey" :title="$store.state.siteName + ` | خانه `"/>
  </div>
</template>

<script>
export default {name:'FrontLayout'}
</script>

<script setup>
import {onMounted, ref} from 'vue'
import Input from "@/components/Input.vue";
import Loading from "@/components/Loading.vue";
import axios from "@/plugins/axios";
import store from "@/store";
import Meta from "@/components/Meta.vue";

let metaKey = ref(1);
let categories = ref([])
let newsCategories = ref([])
let eventCategories = ref([])
let loading = ref(false)
onMounted(async ()=>{
  await getHeaderAndOptions();
})

async function getHeaderAndOptions(){
  await axios.get(`${store.state.api}get-header-options`).then(resp=>{
    let data = resp.data.data;
    categories.value = data.categories;
    newsCategories.value = data.news_categories;
    eventCategories.value = data.event_categories;
    if(data.store_detail){
      store.state.url = data.store_detail.site_url ? data.store_detail.site_url : process.env.VUE_APP_BACKEND;
      store.state.api = data.store_detail.site_url ? data.store_detail.site_url : process.env.VUE_APP_BACKEND;
      store.state.api += '/api/';
      store.dispatch('setFavicon',data.store_detail.favicon)
      store.state.configSite = {...data.store_detail}
      store.state.siteName = data.store_detail.site_name_ir
      metaKey.value ++;
    }
    if(data.social_media){
      store.state.configSite.social_media = {...data.social_media};
    }
  }).catch(err=>{
    console.log(err)
  })
}

async function searchData(text){
  store.state.searchRequest = true;
  loading.value = true;
  await axios.get(`${store.state.api}get-search?search=${text}`).then(resp=>{
    let data = resp.data.data;
    store.state.searchResult = [...data[0], ...data[1]];
  }).catch(err=>{
    console.log(err)
  })
  loading.value = false;
}

</script>